import styled from 'styled-components';
export const MessagesWrapper = styled.div`
    padding: 0 16px;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
`;

export const NoMessagesWrapper = styled.div`
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
`;
